import { Component } from '@angular/core';
import { LandingDesignBase } from '../landing-design-base';

// Diseño 4 de landing: misma cabecera y hero que el diseño 3, con cards compactas a cuatro columnas
// (número + "Abrir" arriba, título y código abajo) y pestañas por sección.
@Component({
  selector: 'app-landing-design-4',
  templateUrl: './landing-design-4.component.html',
  styleUrls: ['./landing-design-4.component.scss'],
})
export class LandingDesign4Component extends LandingDesignBase {}
